import { observer } from 'mobx-react';
import * as React from 'react';
import { AnalyticsProvider, Icon, Text, TIconSize } from 'telia-front-react';

export interface ClientSupportProps {
  children: React.ReactNode;
  icon?: string;
  iconSize?: TIconSize;
}

const ClientSupport = (props: ClientSupportProps): JSX.Element => {
  const { icon = '#support', iconSize = 'xxxl', children } = props;

  return (
    <AnalyticsProvider group="Client Support">
      <Text className="text-center">
        <Icon align="none" size={iconSize} modifiers={icon} />
        <Text>{children}</Text>
      </Text>
    </AnalyticsProvider>
  );
};

export default observer(ClientSupport);
